export class FormularioTraderDadosUsuarioModel {
    nome: string = ""
    email: string = ""
    idade: string = ""
    genero: string = ""
    escolaridade: string = ""
    profissao: string = ""
}